
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personnel",
      function () {
        return require("private-next-pages/personnel/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personnel"])
      });
    }
  